import { createTheme } from "@material-ui/core";
import { Overrides } from "@material-ui/core/styles/overrides";
import { dalCustomColors } from "./dalCustomColors";

export const dalTheme = createTheme({
    palette: {
        primary: {
            main: dalCustomColors.primary
        },
        error: {
            main: dalCustomColors.error
        }
    },
    typography: {
        fontFamily: "FFF AcidGrotesk"
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                boxShadow: "none",
                backgroundColor: dalCustomColors.white,
                "&.Mui-disabled": {
                    backgroundColor: dalCustomColors.white
                },
                border: `2px solid ${dalCustomColors.primary}`,
                "&:hover": {
                    backgroundColor: dalCustomColors.primary,
                    boxShadow: "none",
                    "& .MuiButton-label": {
                        color: dalCustomColors.white
                    }
                }
            },
            root: {
                "&.Mui-disabled": {
                    opacity: 0.2
                },
                textTransform: "none",
                transition: "none",
                borderRadius: 4,
                padding: "16px 24px 16px 24px"
            },
            label: {
                color: dalCustomColors.primary
            }
        },
        MuiCheckbox: {
            root: {
                color: dalCustomColors.disabledElements,
                padding: 0,
                "&.MuiIconButton-colorSecondary:hover": {
                    backgroundColor: "transparent"
                }
            },
            colorSecondary: {
                "&.Mui-checked": {
                    color: dalCustomColors.primary
                }
            }
        },
        MuiChip: {
            root: {
                backgroundColor: dalCustomColors.white,
                border: `1px solid ${dalCustomColors.borderColor}`
            }
        },

        MuiFilledInput: {
            root: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: dalCustomColors.white
                },
                "&.Mui-focused": {
                    backgroundColor: dalCustomColors.white
                }
            }
        },
        MuiTextField: {
            root: {
                borderRadius: 0,
                backgroundColor: dalCustomColors.fieldBackgroundColor
            }
        },
        MuiInputBase: {
            root: {
                height: 56,
                borderBottom: `1px solid ${dalCustomColors.primary}`,
                borderTop: "1px solid transparent",
                "&.Mui-error": {
                    borderBottom: `1px solid ${dalCustomColors.error}`
                }
            },
            multiline: {
                height: "auto"
            },
            input: {
                color: dalCustomColors.primary,
                "&.Mui-disabled": {
                    color: "unset"
                },

                "&::placeholder": {
                    color: dalCustomColors.primary,
                    opacity: 1
                },

                "&::-ms-input-placeholder": {
                    color: dalCustomColors.primary,
                    opacity: 1
                }
            }
        },
        MuiCardContent: {
            root: {
                "&.applicantCard": {
                    borderTop: `1px solid ${dalCustomColors.borderColor}`,
                    borderRight: `1px solid ${dalCustomColors.borderColor}`,
                    borderBottom: `1px solid ${dalCustomColors.borderColor}`
                },
                "&.applicantCardInterviews": {
                    borderLeft: `1px solid ${dalCustomColors.borderColor}`,
                    borderRight: `1px solid ${dalCustomColors.borderColor}`,
                    borderBottom: `1px solid ${dalCustomColors.borderColor}`
                }
            }
        },
        MuiCard: {
            root: {
                "&.blackDalBorder": {
                    border: `1px solid ${dalCustomColors.borderColor}`
                }
            }
        },
        MuiPaper: {
            root: {
                boxShadow: "none !important",
                "&.blackDalBorder": {
                    border: `1px solid ${dalCustomColors.borderColor}`
                }
            }
        },
        MuiPaginationItem: {
            root: {
                color: dalCustomColors.primary,
                border: `1px solid ${dalCustomColors.primary}`
            }
        },
        MuiAutocomplete: {
            inputRoot: {
                paddingTop: "12px !important",
                paddingBottom: 12,
                height: "unset",
                minHeight: 56,
                "&.Mui-focused": {
                    paddingBottom: 10,
                    paddingTop: "10px !important"
                }
            }
        },
        MuiSelect: {
            icon: {
                fill: dalCustomColors.primary
            }
        },
        MuiToggleButton: {
            root: {
                border: "none",
                borderTop: `1px solid ${dalCustomColors.dataUploadBorderColor} !important`,
                borderLeft: `1px solid ${dalCustomColors.dataUploadBorderColor} !important`,
                borderBottom: `1px solid ${dalCustomColors.dataUploadBorderColor} !important`,
                "&.Mui-selected": {
                    backgroundColor: dalCustomColors.white,
                    color: dalCustomColors.dataUploadBorderColor,
                    "& .MuiToggleButton-label": {
                        transform: "scale(1.2)",
                        transition: "transform 0.3s linear"
                    }
                }
            }
        },
        MuiToggleButtonGroup: {
            groupedHorizontal: {
                "&:not(:first-child)": {
                    borderRight: `1px solid ${dalCustomColors.dataUploadBorderColor} !important`
                }
            }
        },
        MuiFormLabel: {
            root: {
                color: dalCustomColors.primary,
                "&.Mui-focused": {
                    color: dalCustomColors.primary,
                    "&.Mui-error": {
                        color: dalCustomColors.error
                    }
                }
            },
            colorSecondary: {
                "&.Mui-focused": {
                    color: dalCustomColors.primary
                }
            }
        },
        MuiListItem: {
            root: {
                "&.Mui-disabled": {
                    opacity: 1
                }
            }
        },
        MuiToolbar: {
            root: {
                "& .MuiPickersToolbarText-toolbarTxt": {
                    color: "#ffffff8a"
                },
                "& .MuiPickersToolbarText-toolbarBtnSelected": {
                    color: dalCustomColors.white
                }
            }
        },
        MuiPickersDay: {
            daySelected: {
                color: dalCustomColors.white
            }
        },
        MuiPickersClockNumber: {
            clockNumberSelected: {
                color: dalCustomColors.white
            }
        },
        MuiTab: {
            root: {
                textTransform: "none"
            },
            textColorInherit: {
                opacity: 1,
                color: dalCustomColors.body1Dark,
                "&.Mui-selected": {
                    color: dalCustomColors.primary,
                    fontWeight: 700
                }
            }
        },
        MuiTableSortLabel: {
            root: {
                "&.MuiTableSortLabel-active": {
                    color: "unset"
                },
                "&:hover": {
                    color: "unset",
                    "& .MuiTableSortLabel-icon": {
                        opacity: 1
                    }
                }
            },
            icon: {
                color: `${dalCustomColors.primary} !important`
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: `1px solid ${dalCustomColors.primary}`,
                fontSize: 12
            }
        },
        MuiSnackbarContent: {
            root: {
                backgroundColor: dalCustomColors.errorBackground,
                color: dalCustomColors.error,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `1px solid ${dalCustomColors.error}`
            }
        }
    }
});
